// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, urlSearchParamsBodySerializer, formDataBodySerializer } from '@hey-api/client-fetch';
import type { StartOrganizationUserMgtAddPublicKeyStartPostData, StartOrganizationUserMgtAddPublicKeyStartPostError, StartOrganizationUserMgtAddPublicKeyStartPostResponse, StartOrganizationUserMgtGetPublicKeysStartPostError, StartOrganizationUserMgtGetPublicKeysStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationsStartPostError, StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse, StartBizArtefactManagementAddArtefactGroupStartPostData, StartBizArtefactManagementAddArtefactGroupStartPostError, StartBizArtefactManagementAddArtefactGroupStartPostResponse, StartBizArtefactManagementRemoveArtefactGroupStartPostData, StartBizArtefactManagementRemoveArtefactGroupStartPostError, StartBizArtefactManagementRemoveArtefactGroupStartPostResponse, StartBizArtefactManagementUpdateArtefactStartPostData, StartBizArtefactManagementUpdateArtefactStartPostError, StartBizArtefactManagementUpdateArtefactStartPostResponse, StartBizArtefactManagementAddArtefactStartPostData, StartBizArtefactManagementAddArtefactStartPostError, StartBizArtefactManagementAddArtefactStartPostResponse, StartBizArtefactManagementGetArtefactsTreeStartPostData, StartBizArtefactManagementGetArtefactsTreeStartPostError, StartBizArtefactManagementGetArtefactsTreeStartPostResponse, StartBizArtefactManagementRemoveArtefactStartPostData, StartBizArtefactManagementRemoveArtefactStartPostError, StartBizArtefactManagementRemoveArtefactStartPostResponse, StartBizArtefactManagementGetHistoryStartPostData, StartBizArtefactManagementGetHistoryStartPostError, StartBizArtefactManagementGetHistoryStartPostResponse, StartBizArtefactManagementRenameArtefactGroupStartPostData, StartBizArtefactManagementRenameArtefactGroupStartPostError, StartBizArtefactManagementRenameArtefactGroupStartPostResponse, StartBizArtefactManagementGetArtefactStartPostData, StartBizArtefactManagementGetArtefactStartPostError, StartBizArtefactManagementGetArtefactStartPostResponse, StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, StartBizArtefactManagementRestoreHistoricalArtefactStartPostError, StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponse, StartBizArtefactManagementRenameArtefactStartPostData, StartBizArtefactManagementRenameArtefactStartPostError, StartBizArtefactManagementRenameArtefactStartPostResponse, StartBizArtefactManagementUpdateArtefactContentStartPostData, StartBizArtefactManagementUpdateArtefactContentStartPostError, StartBizArtefactManagementUpdateArtefactContentStartPostResponse, StartBizEntitiesEntityTypeEntityIdInfoGetData, StartBizEntitiesEntityTypeEntityIdInfoGetError, StartBizEntitiesEntityTypeEntityIdInfoGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeGetData, StartBizEntitiesEntityTypeEntityIdAttributeGetError, StartBizEntitiesEntityTypeEntityIdAttributeGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponse, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse, StartWorkspaceWorktreeMgtGetWorktreeStartPostData, StartWorkspaceWorktreeMgtGetWorktreeStartPostError, StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse, StartStekStekMgtTreeStartPostData, StartStekStekMgtTreeStartPostError, StartStekStekMgtTreeStartPostResponse, StartStekStekMgtUpdateStekConfigurationsStartPostData, StartStekStekMgtUpdateStekConfigurationsStartPostError, StartStekStekMgtUpdateStekConfigurationsStartPostResponse, StartStekStekMgtGetSteksByOrganizationStartPostError, StartStekStekMgtGetSteksByOrganizationStartPostResponse, StartStekStekMgtCreateStekStartPostData, StartStekStekMgtCreateStekStartPostError, StartStekStekMgtCreateStekStartPostResponse, StartStekStekMgtGetStekConfigurationsStartPostError, StartStekStekMgtGetStekConfigurationsStartPostResponse, StartStekStekMgtGetStekStartPostError, StartStekStekMgtGetStekStartPostResponse, StartStekStekMgtDeleteStekStartPostError, StartStekStekMgtDeleteStekStartPostResponse, StartAgentDocPromptStartPostData, StartAgentDocPromptStartPostError, StartAgentDocPromptStartPostResponse, StartProductProductMgtGetProductStartPostData, StartProductProductMgtGetProductStartPostError, StartProductProductMgtGetProductStartPostResponse, StartProductProductMgtUpdateProductStartPostData, StartProductProductMgtUpdateProductStartPostError, StartProductProductMgtUpdateProductStartPostResponse, StartProductProductMgtDeleteProductStartPostData, StartProductProductMgtDeleteProductStartPostError, StartProductProductMgtDeleteProductStartPostResponse, StartProductProductMgtCreateProductStartPostData, StartProductProductMgtCreateProductStartPostError, StartProductProductMgtCreateProductStartPostResponse, StartProductProductMgtGetProductsByDomainStartPostData, StartProductProductMgtGetProductsByDomainStartPostError, StartProductProductMgtGetProductsByDomainStartPostResponse, StartDashboardDashboardMgtGetDashboardsByStekStartPostError, StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse, StartDashboardDashboardMgtUpdateDashboardStartPostData, StartDashboardDashboardMgtUpdateDashboardStartPostError, StartDashboardDashboardMgtUpdateDashboardStartPostResponse, StartDomainDomainMgtDeleteDomainStartPostData, StartDomainDomainMgtDeleteDomainStartPostError, StartDomainDomainMgtDeleteDomainStartPostResponse, StartDomainDomainMgtGetDomainsByStekStartPostError, StartDomainDomainMgtGetDomainsByStekStartPostResponse, StartDomainDomainMgtUpdateDomainStartPostData, StartDomainDomainMgtUpdateDomainStartPostError, StartDomainDomainMgtUpdateDomainStartPostResponse, StartDomainDomainMgtGetDomainStartPostData, StartDomainDomainMgtGetDomainStartPostError, StartDomainDomainMgtGetDomainStartPostResponse, StartDomainDomainMgtCreateDomainStartPostData, StartDomainDomainMgtCreateDomainStartPostError, StartDomainDomainMgtCreateDomainStartPostResponse, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, StartDomainBusinessEntityMgtGetBusinessEntityStartPostError, StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostData, StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostError, StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostResponse, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponse, StartDomainLabelMgtGetLabelsByDomainStartPostData, StartDomainLabelMgtGetLabelsByDomainStartPostError, StartDomainLabelMgtGetLabelsByDomainStartPostResponse, StartDomainLabelMgtLabelTopicStartPostData, StartDomainLabelMgtLabelTopicStartPostError, StartDomainLabelMgtLabelTopicStartPostResponse, StartDomainLabelMgtUnlabelTopicStartPostData, StartDomainLabelMgtUnlabelTopicStartPostError, StartDomainLabelMgtUnlabelTopicStartPostResponse, StartDomainLabelMgtGetLabelsByTopicStartPostData, StartDomainLabelMgtGetLabelsByTopicStartPostError, StartDomainLabelMgtGetLabelsByTopicStartPostResponse, StartDomainLabelMgtCreateLabelStartPostData, StartDomainLabelMgtCreateLabelStartPostError, StartDomainLabelMgtCreateLabelStartPostResponse, StartDomainRoleMgtGetRolesStartPostData, StartDomainRoleMgtGetRolesStartPostError, StartDomainRoleMgtGetRolesStartPostResponse, StartDomainRoleMgtCreateRoleStartPostData, StartDomainRoleMgtCreateRoleStartPostError, StartDomainRoleMgtCreateRoleStartPostResponse, StartDomainRoleMgtUpdateRoleStartPostData, StartDomainRoleMgtUpdateRoleStartPostError, StartDomainRoleMgtUpdateRoleStartPostResponse, StartDomainRoleMgtDeleteRoleStartPostData, StartDomainRoleMgtDeleteRoleStartPostError, StartDomainRoleMgtDeleteRoleStartPostResponse, StartDomainRoleMgtGetRoleStartPostData, StartDomainRoleMgtGetRoleStartPostError, StartDomainRoleMgtGetRoleStartPostResponse, StartDomainTopicMgtGetTopicStartPostData, StartDomainTopicMgtGetTopicStartPostError, StartDomainTopicMgtGetTopicStartPostResponse, StartDomainTopicMgtUpdateTopicStartPostData, StartDomainTopicMgtUpdateTopicStartPostError, StartDomainTopicMgtUpdateTopicStartPostResponse, StartDomainTopicMgtCreateReplyStartPostData, StartDomainTopicMgtCreateReplyStartPostError, StartDomainTopicMgtCreateReplyStartPostResponse, StartDomainTopicMgtGetRepliesOnTopicStartPostData, StartDomainTopicMgtGetRepliesOnTopicStartPostError, StartDomainTopicMgtGetRepliesOnTopicStartPostResponse, StartDomainTopicMgtCreateTopicStartPostData, StartDomainTopicMgtCreateTopicStartPostError, StartDomainTopicMgtCreateTopicStartPostResponse, StartDomainTopicMgtGetTopicsByDomainStartPostData, StartDomainTopicMgtGetTopicsByDomainStartPostError, StartDomainTopicMgtGetTopicsByDomainStartPostResponse, StartProcessLaneMgtGetLaneStartPostData, StartProcessLaneMgtGetLaneStartPostError, StartProcessLaneMgtGetLaneStartPostResponse, StartProcessLaneMgtGetLaneByRoleIdStartPostData, StartProcessLaneMgtGetLaneByRoleIdStartPostError, StartProcessLaneMgtGetLaneByRoleIdStartPostResponse, StartProcessLaneMgtGetLaneByBpmnIdStartPostData, StartProcessLaneMgtGetLaneByBpmnIdStartPostError, StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse, StartProcessLaneMgtGetLanesByProcessStartPostData, StartProcessLaneMgtGetLanesByProcessStartPostError, StartProcessLaneMgtGetLanesByProcessStartPostResponse, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse, StartProcessProcessElementMgtDeleteGatewayStartPostData, StartProcessProcessElementMgtDeleteGatewayStartPostError, StartProcessProcessElementMgtDeleteGatewayStartPostResponse, StartProcessProcessElementMgtUpdateEventStartPostData, StartProcessProcessElementMgtUpdateEventStartPostError, StartProcessProcessElementMgtUpdateEventStartPostResponse, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse, StartProcessProcessElementMgtUpdateGatewayStartPostData, StartProcessProcessElementMgtUpdateGatewayStartPostError, StartProcessProcessElementMgtUpdateGatewayStartPostResponse, StartProcessProcessElementMgtGetEventStartPostData, StartProcessProcessElementMgtGetEventStartPostError, StartProcessProcessElementMgtGetEventStartPostResponse, StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, StartProcessProcessElementMgtUnarchiveProcessElementStartPostError, StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponse, StartProcessProcessElementMgtDeleteEventStartPostData, StartProcessProcessElementMgtDeleteEventStartPostError, StartProcessProcessElementMgtDeleteEventStartPostResponse, StartProcessProcessElementMgtArchiveProcessElementStartPostData, StartProcessProcessElementMgtArchiveProcessElementStartPostError, StartProcessProcessElementMgtArchiveProcessElementStartPostResponse, StartProcessProcessElementMgtDeleteTaskStartPostData, StartProcessProcessElementMgtDeleteTaskStartPostError, StartProcessProcessElementMgtDeleteTaskStartPostResponse, StartProcessProcessElementMgtGetTaskStartPostData, StartProcessProcessElementMgtGetTaskStartPostError, StartProcessProcessElementMgtGetTaskStartPostResponse, StartProcessProcessElementMgtUpdateFlowStartPostData, StartProcessProcessElementMgtUpdateFlowStartPostError, StartProcessProcessElementMgtUpdateFlowStartPostResponse, StartProcessProcessElementMgtGetGatewayStartPostData, StartProcessProcessElementMgtGetGatewayStartPostError, StartProcessProcessElementMgtGetGatewayStartPostResponse, StartProcessProcessElementMgtUpdateTaskStartPostData, StartProcessProcessElementMgtUpdateTaskStartPostError, StartProcessProcessElementMgtUpdateTaskStartPostResponse, StartProcessProcessElementMgtGetFlowStartPostData, StartProcessProcessElementMgtGetFlowStartPostError, StartProcessProcessElementMgtGetFlowStartPostResponse, StartProcessProcessElementMgtDeleteFlowStartPostData, StartProcessProcessElementMgtDeleteFlowStartPostError, StartProcessProcessElementMgtDeleteFlowStartPostResponse, StartProcessProcessMgtGetProcessStartPostData, StartProcessProcessMgtGetProcessStartPostError, StartProcessProcessMgtGetProcessStartPostResponse, StartProcessProcessMgtMoveProcessStartPostData, StartProcessProcessMgtMoveProcessStartPostError, StartProcessProcessMgtMoveProcessStartPostResponse, StartProcessProcessMgtGenerateDefinitionStartPostData, StartProcessProcessMgtGenerateDefinitionStartPostError, StartProcessProcessMgtGenerateDefinitionStartPostResponse, StartProcessProcessMgtDeployProcessStartPostData, StartProcessProcessMgtDeployProcessStartPostError, StartProcessProcessMgtDeployProcessStartPostResponse, StartProcessProcessMgtUpdateProcessStartPostData, StartProcessProcessMgtUpdateProcessStartPostError, StartProcessProcessMgtUpdateProcessStartPostResponse, StartProcessProcessMgtDeleteProcessStartPostData, StartProcessProcessMgtDeleteProcessStartPostError, StartProcessProcessMgtDeleteProcessStartPostResponse, StartProcessProcessMgtCreateProcessStartPostData, StartProcessProcessMgtCreateProcessStartPostError, StartProcessProcessMgtCreateProcessStartPostResponse, StartProcessProcessMgtGetProcessesByProductStartPostData, StartProcessProcessMgtGetProcessesByProductStartPostError, StartProcessProcessMgtGetProcessesByProductStartPostResponse, GetUsersUserGetError, GetUsersUserGetResponse, CreateUserUserPostData, CreateUserUserPostError, CreateUserUserPostResponse, DeleteUserUserUserIdDeleteData, DeleteUserUserUserIdDeleteError, DeleteUserUserUserIdDeleteResponse, GetSelfUserMeGetError, GetSelfUserMeGetResponse, GetDomainRolesUserUserIdDomainRolesGetData, GetDomainRolesUserUserIdDomainRolesGetError, GetDomainRolesUserUserIdDomainRolesGetResponse, MakeUserManagerUserUserIdMakeUserManagerPostData, MakeUserManagerUserUserIdMakeUserManagerPostError, MakeUserManagerUserUserIdMakeUserManagerPostResponse, MakeUserUserUserIdMakeUserPostData, MakeUserUserUserIdMakeUserPostError, MakeUserUserUserIdMakeUserPostResponse, PreviewLinkProxyPreviewLinkGetData, PreviewLinkProxyPreviewLinkGetError, PreviewLinkProxyPreviewLinkGetResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Start
 * Add a public key for a User.
 */
export const startOrganizationUserMgtAddPublicKeyStartPost = <ThrowOnError extends boolean = false>(options: Options<StartOrganizationUserMgtAddPublicKeyStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartOrganizationUserMgtAddPublicKeyStartPostResponse, StartOrganizationUserMgtAddPublicKeyStartPostError, ThrowOnError>({
        ...options,
        url: '/organization/user_mgt/add_public_key/start'
    });
};

/**
 * Start
 * Get public keys for user.
 */
export const startOrganizationUserMgtGetPublicKeysStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartOrganizationUserMgtGetPublicKeysStartPostResponse, StartOrganizationUserMgtGetPublicKeysStartPostError, ThrowOnError>({
        ...options,
        url: '/organization/user_mgt/get_public_keys/start'
    });
};

/**
 * Start
 * Get a list of organizations that current logged-in user has access to.
 */
export const startOrganizationOrganizationMgtGetOrganizationsStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationsStartPostError, ThrowOnError>({
        ...options,
        url: '/organization/organization_mgt/get_organizations/start'
    });
};

/**
 * Start
 * Get Domain
 */
export const startOrganizationOrganizationMgtGetOrganizationByNameStartPost = <ThrowOnError extends boolean = false>(options: Options<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError, ThrowOnError>({
        ...options,
        url: '/organization/organization_mgt/get_organization_by_name/start'
    });
};

/**
 * Start
 * Add artefact group to an entity
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * name: str - The name of the artefact group
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementAddArtefactGroupStartPostResponse, StartBizArtefactManagementAddArtefactGroupStartPostError, ThrowOnError>({
        ...options,
        ...urlSearchParamsBodySerializer,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options?.headers
        },
        url: '/biz/artefact_management/add_artefact_group/start'
    });
};

/**
 * Start
 * Remove an Artefact group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact group to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementRemoveArtefactGroupStartPostResponse, StartBizArtefactManagementRemoveArtefactGroupStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/remove_artefact_group/start'
    });
};

/**
 * Start
 * Update an Artefact. Any parameters given will be updated.
 *
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update.
 * content: File - The file contents to update.
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}".
 * user_email: str - The email of the user making the request.
 */
export const startBizArtefactManagementUpdateArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementUpdateArtefactStartPostResponse, StartBizArtefactManagementUpdateArtefactStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/biz/artefact_management/update_artefact/start'
    });
};

/**
 * Start
 * Add an artefact to an entity.
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementAddArtefactStartPostResponse, StartBizArtefactManagementAddArtefactStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/biz/artefact_management/add_artefact/start'
    });
};

/**
 * Start
 * Get artefact tree for given Entity containing directories and files
 */
export const startBizArtefactManagementGetArtefactsTreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactsTreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementGetArtefactsTreeStartPostResponse, StartBizArtefactManagementGetArtefactsTreeStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/get_artefacts_tree/start'
    });
};

/**
 * Start
 * Remove an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementRemoveArtefactStartPostResponse, StartBizArtefactManagementRemoveArtefactStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/remove_artefact/start'
    });
};

/**
 * Start
 * Get the history of a given artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to get the history of
 * - limit?: int - The maximum number of history items to return, defaults to 10
 * - offset?: int - The number of history items to skip, defaults to 0
 */
export const startBizArtefactManagementGetHistoryStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetHistoryStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementGetHistoryStartPostResponse, StartBizArtefactManagementGetHistoryStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/get_history/start'
    });
};

/**
 * Start
 * Rename an Artefact Group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact Group to rename
 * - name: str - The new name of the Artefact Group
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementRenameArtefactGroupStartPostResponse, StartBizArtefactManagementRenameArtefactGroupStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/rename_artefact_group/start'
    });
};

/**
 * Start
 * Get the artefact in the given location
 *
 * Request params:
 * - artefact_id: str - The identity of the artefact to get
 * - revision: str - Optional revision of the artefact to get
 */
export const startBizArtefactManagementGetArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementGetArtefactStartPostResponse, StartBizArtefactManagementGetArtefactStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/get_artefact/start'
    });
};

/**
 * Start
 * Restore an Artefact from the history.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - revision?: str - The revision to restore the artefact from
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRestoreHistoricalArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponse, StartBizArtefactManagementRestoreHistoricalArtefactStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/restore_historical_artefact/start'
    });
};

/**
 * @deprecated
 * Start
 * Rename an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to rename
 * - name: str - The new name of the Artefact
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementRenameArtefactStartPostResponse, StartBizArtefactManagementRenameArtefactStartPostError, ThrowOnError>({
        ...options,
        url: '/biz/artefact_management/rename_artefact/start'
    });
};

/**
 * @deprecated
 * Start
 * Add a file artefact to an entity
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementUpdateArtefactContentStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactContentStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizArtefactManagementUpdateArtefactContentStartPostResponse, StartBizArtefactManagementUpdateArtefactContentStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/biz/artefact_management/update_artefact_content/start'
    });
};

/**
 * Start
 * Get entity info
 */
export const startBizEntitiesEntityTypeEntityIdInfoGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdInfoGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<StartBizEntitiesEntityTypeEntityIdInfoGetResponse, StartBizEntitiesEntityTypeEntityIdInfoGetError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/info'
    });
};

/**
 * Start
 * Get the entity in the given location using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 */
export const startBizEntitiesEntityTypeEntityIdAttributeGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<StartBizEntitiesEntityTypeEntityIdAttributeGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeGetError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}'
    });
};

/**
 * Start
 * Get the entity history using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - limit: int - The number of history items to return
 * - offset: int - The number of history items to skip
 */
export const startBizEntitiesEntityTypeEntityIdAttributeHistoryGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/history'
    });
};

/**
 * Start
 * Restore an entity to a previous version.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - revision: str - The revision to restore
 */
export const startBizEntitiesEntityTypeEntityIdAttributeRestorePost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponse, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/restore'
    });
};

/**
 * Start
 * Generate an entity description
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateDescriptionPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/generate_description'
    });
};

/**
 * Start
 * Generate an entity children based on the context available.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateChildrenPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError, ThrowOnError>({
        ...options,
        url: '/biz/entities/{entity_type}/{entity_id}/generate_children'
    });
};

/**
 * Start
 * Get Workspace by Stek
 */
export const startWorkspaceWorktreeMgtGetWorktreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartWorkspaceWorktreeMgtGetWorktreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse, StartWorkspaceWorktreeMgtGetWorktreeStartPostError, ThrowOnError>({
        ...options,
        url: '/workspace/worktree_mgt/get_worktree/start'
    });
};

/**
 * Start
 * Get tree for given Stek containing all directories and files
 */
export const startStekStekMgtTreeStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtTreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtTreeStartPostResponse, StartStekStekMgtTreeStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/tree/start'
    });
};

/**
 * Start
 * Update configurations for a stek.
 */
export const startStekStekMgtUpdateStekConfigurationsStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtUpdateStekConfigurationsStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtUpdateStekConfigurationsStartPostResponse, StartStekStekMgtUpdateStekConfigurationsStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/update_stek_configurations/start'
    });
};

/**
 * Start
 * Get Steks by Organization
 */
export const startStekStekMgtGetSteksByOrganizationStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtGetSteksByOrganizationStartPostResponse, StartStekStekMgtGetSteksByOrganizationStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/get_steks_by_organization/start'
    });
};

/**
 * Start
 * Create a new Stek
 */
export const startStekStekMgtCreateStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtCreateStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtCreateStekStartPostResponse, StartStekStekMgtCreateStekStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/create_stek/start'
    });
};

/**
 * Start
 * Get configurations for a stek.
 */
export const startStekStekMgtGetStekConfigurationsStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtGetStekConfigurationsStartPostResponse, StartStekStekMgtGetStekConfigurationsStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/get_stek_configurations/start'
    });
};

/**
 * Start
 * Get Stek
 */
export const startStekStekMgtGetStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtGetStekStartPostResponse, StartStekStekMgtGetStekStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/get_stek/start'
    });
};

/**
 * Start
 * Delete a STek
 */
export const startStekStekMgtDeleteStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartStekStekMgtDeleteStekStartPostResponse, StartStekStekMgtDeleteStekStartPostError, ThrowOnError>({
        ...options,
        url: '/stek/stek_mgt/delete_stek/start'
    });
};

/**
 * Start
 * Get response from doc
 */
export const startAgentDocPromptStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAgentDocPromptStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartAgentDocPromptStartPostResponse, StartAgentDocPromptStartPostError, ThrowOnError>({
        ...options,
        url: '/agent/doc/prompt/start'
    });
};

/**
 * Start
 * Get Product
 */
export const startProductProductMgtGetProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProductProductMgtGetProductStartPostResponse, StartProductProductMgtGetProductStartPostError, ThrowOnError>({
        ...options,
        url: '/product/product_mgt/get_product/start'
    });
};

/**
 * Start
 * Update a Product
 */
export const startProductProductMgtUpdateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtUpdateProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProductProductMgtUpdateProductStartPostResponse, StartProductProductMgtUpdateProductStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/product/product_mgt/update_product/start'
    });
};

/**
 * Start
 * Delete a Product
 */
export const startProductProductMgtDeleteProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtDeleteProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProductProductMgtDeleteProductStartPostResponse, StartProductProductMgtDeleteProductStartPostError, ThrowOnError>({
        ...options,
        url: '/product/product_mgt/delete_product/start'
    });
};

/**
 * Start
 * Create a new Product
 */
export const startProductProductMgtCreateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtCreateProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProductProductMgtCreateProductStartPostResponse, StartProductProductMgtCreateProductStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/product/product_mgt/create_product/start'
    });
};

/**
 * Start
 * Get Products by Domain
 */
export const startProductProductMgtGetProductsByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductsByDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProductProductMgtGetProductsByDomainStartPostResponse, StartProductProductMgtGetProductsByDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/product/product_mgt/get_products_by_domain/start'
    });
};

/**
 * Start
 * Get Dashboards by Stek
 */
export const startDashboardDashboardMgtGetDashboardsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse, StartDashboardDashboardMgtGetDashboardsByStekStartPostError, ThrowOnError>({
        ...options,
        url: '/dashboard/dashboard_mgt/get_dashboards_by_stek/start'
    });
};

/**
 * Start
 * Update a specific dashboard.
 */
export const startDashboardDashboardMgtUpdateDashboardStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDashboardDashboardMgtUpdateDashboardStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDashboardDashboardMgtUpdateDashboardStartPostResponse, StartDashboardDashboardMgtUpdateDashboardStartPostError, ThrowOnError>({
        ...options,
        url: '/dashboard/dashboard_mgt/update_dashboard/start'
    });
};

/**
 * Start
 * Delete a Domain
 */
export const startDomainDomainMgtDeleteDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtDeleteDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainDomainMgtDeleteDomainStartPostResponse, StartDomainDomainMgtDeleteDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/domain_mgt/delete_domain/start'
    });
};

/**
 * Start
 * Get Domains by Stek
 */
export const startDomainDomainMgtGetDomainsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainDomainMgtGetDomainsByStekStartPostResponse, StartDomainDomainMgtGetDomainsByStekStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/domain_mgt/get_domains_by_stek/start'
    });
};

/**
 * Start
 * Update a domain.
 */
export const startDomainDomainMgtUpdateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtUpdateDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainDomainMgtUpdateDomainStartPostResponse, StartDomainDomainMgtUpdateDomainStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/domain/domain_mgt/update_domain/start'
    });
};

/**
 * Start
 * Get Domain
 */
export const startDomainDomainMgtGetDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtGetDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainDomainMgtGetDomainStartPostResponse, StartDomainDomainMgtGetDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/domain_mgt/get_domain/start'
    });
};

/**
 * Start
 * Create a new Domain
 */
export const startDomainDomainMgtCreateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtCreateDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainDomainMgtCreateDomainStartPostResponse, StartDomainDomainMgtCreateDomainStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/domain/domain_mgt/create_domain/start'
    });
};

/**
 * Start
 * Update a business entity details and/or definition.
 */
export const startDomainBusinessEntityMgtUpdateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/business_entity_mgt/update_business_entity/start'
    });
};

/**
 * Start
 * Get a business entity.
 */
export const startDomainBusinessEntityMgtGetBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntityStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/business_entity_mgt/get_business_entity/start'
    });
};

/**
 * Start
 * Get a list of business entities belonging to a domain
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/business_entity_mgt/get_business_entities_by_domain/start'
    });
};

/**
 * Start
 * Create a new business entity.
 */
export const startDomainBusinessEntityMgtCreateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/business_entity_mgt/create_business_entity/start'
    });
};

/**
 * Start
 * Delete a business entity.
 */
export const startDomainBusinessEntityMgtDeleteBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/business_entity_mgt/delete_business_entity/start'
    });
};

/**
 * Start
 * Get all Label(s) for provided Domain
 */
export const startDomainLabelMgtGetLabelsByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainLabelMgtGetLabelsByDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainLabelMgtGetLabelsByDomainStartPostResponse, StartDomainLabelMgtGetLabelsByDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/label_mgt/get_labels_by_domain/start'
    });
};

/**
 * Start
 * Add a Label to a Topic
 */
export const startDomainLabelMgtLabelTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainLabelMgtLabelTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainLabelMgtLabelTopicStartPostResponse, StartDomainLabelMgtLabelTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/label_mgt/label_topic/start'
    });
};

/**
 * Start
 * Remove a Label from a Topic
 */
export const startDomainLabelMgtUnlabelTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainLabelMgtUnlabelTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainLabelMgtUnlabelTopicStartPostResponse, StartDomainLabelMgtUnlabelTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/label_mgt/unlabel_topic/start'
    });
};

/**
 * Start
 * Get all Label(s) for provided Topic.
 */
export const startDomainLabelMgtGetLabelsByTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainLabelMgtGetLabelsByTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainLabelMgtGetLabelsByTopicStartPostResponse, StartDomainLabelMgtGetLabelsByTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/label_mgt/get_labels_by_topic/start'
    });
};

/**
 * Start
 * Create Label in Domain
 */
export const startDomainLabelMgtCreateLabelStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainLabelMgtCreateLabelStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainLabelMgtCreateLabelStartPostResponse, StartDomainLabelMgtCreateLabelStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/label_mgt/create_label/start'
    });
};

/**
 * Start
 * Get all Role(s) for provided Domain
 */
export const startDomainRoleMgtGetRolesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRolesStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainRoleMgtGetRolesStartPostResponse, StartDomainRoleMgtGetRolesStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/role_mgt/get_roles/start'
    });
};

/**
 * Start
 * Create Role in Domain
 */
export const startDomainRoleMgtCreateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtCreateRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainRoleMgtCreateRoleStartPostResponse, StartDomainRoleMgtCreateRoleStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/domain/role_mgt/create_role/start'
    });
};

/**
 * Start
 * Update a Role.
 */
export const startDomainRoleMgtUpdateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtUpdateRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainRoleMgtUpdateRoleStartPostResponse, StartDomainRoleMgtUpdateRoleStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/domain/role_mgt/update_role/start'
    });
};

/**
 * Start
 * Delete Role
 */
export const startDomainRoleMgtDeleteRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtDeleteRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainRoleMgtDeleteRoleStartPostResponse, StartDomainRoleMgtDeleteRoleStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/role_mgt/delete_role/start'
    });
};

/**
 * Start
 * Get Role
 */
export const startDomainRoleMgtGetRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainRoleMgtGetRoleStartPostResponse, StartDomainRoleMgtGetRoleStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/role_mgt/get_role/start'
    });
};

/**
 * Start
 * Get a Topic.
 *
 * A Topic is unique by name within a Damain.
 */
export const startDomainTopicMgtGetTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtGetTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtGetTopicStartPostResponse, StartDomainTopicMgtGetTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/get_topic/start'
    });
};

/**
 * Start
 * Update Topic.
 */
export const startDomainTopicMgtUpdateTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtUpdateTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtUpdateTopicStartPostResponse, StartDomainTopicMgtUpdateTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/update_topic/start'
    });
};

/**
 * Start
 * Create Reply on a Topic.
 */
export const startDomainTopicMgtCreateReplyStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtCreateReplyStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtCreateReplyStartPostResponse, StartDomainTopicMgtCreateReplyStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/create_reply/start'
    });
};

/**
 * Start
 * Get Topic replies.
 */
export const startDomainTopicMgtGetRepliesOnTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtGetRepliesOnTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtGetRepliesOnTopicStartPostResponse, StartDomainTopicMgtGetRepliesOnTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/get_replies_on_topic/start'
    });
};

/**
 * Start
 * Create Topic in Domain
 */
export const startDomainTopicMgtCreateTopicStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtCreateTopicStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtCreateTopicStartPostResponse, StartDomainTopicMgtCreateTopicStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/create_topic/start'
    });
};

/**
 * Start
 * Get Topics by Domain.
 */
export const startDomainTopicMgtGetTopicsByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainTopicMgtGetTopicsByDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartDomainTopicMgtGetTopicsByDomainStartPostResponse, StartDomainTopicMgtGetTopicsByDomainStartPostError, ThrowOnError>({
        ...options,
        url: '/domain/topic_mgt/get_topics_by_domain/start'
    });
};

/**
 * Start
 * Get Lane
 */
export const startProcessLaneMgtGetLaneStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessLaneMgtGetLaneStartPostResponse, StartProcessLaneMgtGetLaneStartPostError, ThrowOnError>({
        ...options,
        url: '/process/lane_mgt/get_lane/start'
    });
};

/**
 * Start
 * Get Lane by Role Id.
 */
export const startProcessLaneMgtGetLaneByRoleIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByRoleIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessLaneMgtGetLaneByRoleIdStartPostResponse, StartProcessLaneMgtGetLaneByRoleIdStartPostError, ThrowOnError>({
        ...options,
        url: '/process/lane_mgt/get_lane_by_role_id/start'
    });
};

/**
 * Start
 * Get Lane by BPMN ID.
 */
export const startProcessLaneMgtGetLaneByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByBpmnIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse, StartProcessLaneMgtGetLaneByBpmnIdStartPostError, ThrowOnError>({
        ...options,
        url: '/process/lane_mgt/get_lane_by_bpmn_id/start'
    });
};

/**
 * Start
 * Get Lanes by Process.
 */
export const startProcessLaneMgtGetLanesByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLanesByProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessLaneMgtGetLanesByProcessStartPostResponse, StartProcessLaneMgtGetLanesByProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/lane_mgt/get_lanes_by_process/start'
    });
};

/**
 * Start
 * Get Task
 */
export const startProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_process_element_by_bpmn_id/start'
    });
};

/**
 * Start
 * Delete Gateway
 */
export const startProcessProcessElementMgtDeleteGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtDeleteGatewayStartPostResponse, StartProcessProcessElementMgtDeleteGatewayStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/delete_gateway/start'
    });
};

/**
 * Start
 * Update event.
 */
export const startProcessProcessElementMgtUpdateEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtUpdateEventStartPostResponse, StartProcessProcessElementMgtUpdateEventStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_element_mgt/update_event/start'
    });
};

/**
 * Start
 * Get Tasks by Process.
 */
export const startProcessProcessElementMgtGetProcessElementsByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_process_elements_by_process/start'
    });
};

/**
 * Start
 * Update gateway.
 */
export const startProcessProcessElementMgtUpdateGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtUpdateGatewayStartPostResponse, StartProcessProcessElementMgtUpdateGatewayStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_element_mgt/update_gateway/start'
    });
};

/**
 * Start
 * Get Event.
 */
export const startProcessProcessElementMgtGetEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetEventStartPostResponse, StartProcessProcessElementMgtGetEventStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_event/start'
    });
};

/**
 * Start
 * Unarchive Process Element.
 */
export const startProcessProcessElementMgtUnarchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponse, StartProcessProcessElementMgtUnarchiveProcessElementStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/unarchive_process_element/start'
    });
};

/**
 * Start
 * Delete Event
 */
export const startProcessProcessElementMgtDeleteEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtDeleteEventStartPostResponse, StartProcessProcessElementMgtDeleteEventStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/delete_event/start'
    });
};

/**
 * Start
 * Archive Task
 */
export const startProcessProcessElementMgtArchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtArchiveProcessElementStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtArchiveProcessElementStartPostResponse, StartProcessProcessElementMgtArchiveProcessElementStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/archive_process_element/start'
    });
};

/**
 * Start
 * Delete Task
 */
export const startProcessProcessElementMgtDeleteTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtDeleteTaskStartPostResponse, StartProcessProcessElementMgtDeleteTaskStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/delete_task/start'
    });
};

/**
 * Start
 * Get Task.
 */
export const startProcessProcessElementMgtGetTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetTaskStartPostResponse, StartProcessProcessElementMgtGetTaskStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_task/start'
    });
};

/**
 * Start
 * Update flow.
 */
export const startProcessProcessElementMgtUpdateFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtUpdateFlowStartPostResponse, StartProcessProcessElementMgtUpdateFlowStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_element_mgt/update_flow/start'
    });
};

/**
 * Start
 * Get Gateway.
 */
export const startProcessProcessElementMgtGetGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetGatewayStartPostResponse, StartProcessProcessElementMgtGetGatewayStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_gateway/start'
    });
};

/**
 * Start
 * Update task.
 */
export const startProcessProcessElementMgtUpdateTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtUpdateTaskStartPostResponse, StartProcessProcessElementMgtUpdateTaskStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_element_mgt/update_task/start'
    });
};

/**
 * Start
 * Get Flow.
 */
export const startProcessProcessElementMgtGetFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtGetFlowStartPostResponse, StartProcessProcessElementMgtGetFlowStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/get_flow/start'
    });
};

/**
 * Start
 * Delete Flow
 */
export const startProcessProcessElementMgtDeleteFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessElementMgtDeleteFlowStartPostResponse, StartProcessProcessElementMgtDeleteFlowStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_element_mgt/delete_flow/start'
    });
};

/**
 * Start
 * Get Process
 */
export const startProcessProcessMgtGetProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtGetProcessStartPostResponse, StartProcessProcessMgtGetProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/get_process/start'
    });
};

/**
 * Start
 * Move a Process to a new Product.
 */
export const startProcessProcessMgtMoveProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtMoveProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtMoveProcessStartPostResponse, StartProcessProcessMgtMoveProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/move_process/start'
    });
};

/**
 * Start
 * Generate a Process definition.
 */
export const startProcessProcessMgtGenerateDefinitionStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGenerateDefinitionStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtGenerateDefinitionStartPostResponse, StartProcessProcessMgtGenerateDefinitionStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/generate_definition/start'
    });
};

/**
 * Start
 * Deploy a Process to process engine.
 *
 * Returns:
 * resp (dict): Of the form:
 * {'deployment_id': str}
 */
export const startProcessProcessMgtDeployProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeployProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtDeployProcessStartPostResponse, StartProcessProcessMgtDeployProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/deploy_process/start'
    });
};

/**
 * Start
 * Update a process.
 */
export const startProcessProcessMgtUpdateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtUpdateProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtUpdateProcessStartPostResponse, StartProcessProcessMgtUpdateProcessStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_mgt/update_process/start'
    });
};

/**
 * Start
 * Delete a Process
 */
export const startProcessProcessMgtDeleteProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeleteProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtDeleteProcessStartPostResponse, StartProcessProcessMgtDeleteProcessStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/delete_process/start'
    });
};

/**
 * Start
 * Create a new Process
 */
export const startProcessProcessMgtCreateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtCreateProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtCreateProcessStartPostResponse, StartProcessProcessMgtCreateProcessStartPostError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/process/process_mgt/create_process/start'
    });
};

/**
 * Start
 * Get Processes by Product.
 */
export const startProcessProcessMgtGetProcessesByProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessesByProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<StartProcessProcessMgtGetProcessesByProductStartPostResponse, StartProcessProcessMgtGetProcessesByProductStartPostError, ThrowOnError>({
        ...options,
        url: '/process/process_mgt/get_processes_by_product/start'
    });
};

/**
 * Get Users
 * Get all users.
 */
export const getUsersUserGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersUserGetResponse, GetUsersUserGetError, ThrowOnError>({
        ...options,
        url: '/user/'
    });
};

/**
 * Create User
 * Create a user.
 */
export const createUserUserPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserUserPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserUserPostResponse, CreateUserUserPostError, ThrowOnError>({
        ...options,
        url: '/user/'
    });
};

/**
 * Delete User
 * Delete a User.
 */
export const deleteUserUserUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserUserUserIdDeleteData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserUserUserIdDeleteResponse, DeleteUserUserUserIdDeleteError, ThrowOnError>({
        ...options,
        url: '/user/{user_id}'
    });
};

/**
 * Get Self
 * Get currently logged in user.
 */
export const getSelfUserMeGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSelfUserMeGetResponse, GetSelfUserMeGetError, ThrowOnError>({
        ...options,
        url: '/user/me'
    });
};

/**
 * Get Domain Roles
 * Get roles for given domain.
 */
export const getDomainRolesUserUserIdDomainRolesGet = <ThrowOnError extends boolean = false>(options: Options<GetDomainRolesUserUserIdDomainRolesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDomainRolesUserUserIdDomainRolesGetResponse, GetDomainRolesUserUserIdDomainRolesGetError, ThrowOnError>({
        ...options,
        url: '/user/{user_id}/domain-roles'
    });
};

/**
 * Make User Manager
 * Make user a user manager.
 */
export const makeUserManagerUserUserIdMakeUserManagerPost = <ThrowOnError extends boolean = false>(options: Options<MakeUserManagerUserUserIdMakeUserManagerPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<MakeUserManagerUserUserIdMakeUserManagerPostResponse, MakeUserManagerUserUserIdMakeUserManagerPostError, ThrowOnError>({
        ...options,
        url: '/user/{user_id}/make-user-manager'
    });
};

/**
 * Make User
 * Make user a regular user (not user manager).
 */
export const makeUserUserUserIdMakeUserPost = <ThrowOnError extends boolean = false>(options: Options<MakeUserUserUserIdMakeUserPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<MakeUserUserUserIdMakeUserPostResponse, MakeUserUserUserIdMakeUserPostError, ThrowOnError>({
        ...options,
        url: '/user/{user_id}/make-user'
    });
};

/**
 * Preview Link
 * Get the metadata from a weblink based on the HTML.
 */
export const previewLinkProxyPreviewLinkGet = <ThrowOnError extends boolean = false>(options: Options<PreviewLinkProxyPreviewLinkGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<PreviewLinkProxyPreviewLinkGetResponse, PreviewLinkProxyPreviewLinkGetError, ThrowOnError>({
        ...options,
        url: '/proxy/preview-link'
    });
};